import React from "react";
import WorksSlider from "../WorksSlider/WorksSlider";
import "./PortfolioSection.css";
import Testimonial from "./Testimonial/Testimonial";
import useReveal from "../../hooks/useReveal";


const PortfolioSection = () => {
  const textRef = useReveal();
  const moreRef = useReveal();

  return (
    <section id="portfolio" className="portfolio-wrapper">
      <div className="portfolio-blur-shape" aria-hidden="true" />
      <div className="portfolio-blur-shape two" aria-hidden="true" />

      <div className="portfolio-text reveal" ref={textRef}>
        <h5>PORTFOLIO</h5>
        <h2>
          Projects that reflect my <br />
          expertise and vision.
        </h2>
      </div>

      {/* SLIDER */}
      <WorksSlider />
      <div className="more-projects reveal" ref={moreRef}>
          <h3>Not Satisfied?</h3>
        <a href="https://drive.google.com/drive/folders/1Odbc_PQ3PjWPNmTIQNRkF7doesPTTCZH?usp=drive_link">
        <button className="view-more-btn">
          <span>View More Projects</span>
          <span className="arrow-circle">
            <span className="arrow"></span>
          </span>
        </button>
        </a>
      </div>
      <Testimonial />
    </section>
  );
};

export default PortfolioSection;
